import BaseMarkerLayer from '@/utils/layers/marker/BaseMarkerLayer'
import { TimestampUtil } from '@/utils/timestampUtil'
import { newIcon, newMarker } from '@/utils/markerUtil'
import { deepCopy } from '@/utils/miscUtil'
import { FeatureUtil } from '@/utils/featureUtil'
import { Map2DUtil, BaseMap2DView } from '@/utils/mapUtil'
import { isArray } from 'util'

// 图层组定义
const groups = ['base', 'custom', 'default']

/**
 * 基础地图（单实例）
 */
export const MapView = {
    vm:null,
    /**
     * 右键菜单
     */
    RightMenu: null,

    /**
     * 起点终点推荐点MarkerLayer（公用一个）
     */
    RouteMarker: null,

    /**
     * 初始化地图
     * @param {String} div
     */
    async initMap(vm,div) {
        this.vm = vm;
        return Map2DUtil.createMap(div, global.CONFIG.centerConf).then(
            map2d => {
                // 继承mapview对象
                const mapView = new BaseMap2DView(map2d, groups)
                this._extend(mapView)

                // 初始化控件相关
                Map2DUtil.initControls(map2d)
                this.RightMenu = Map2DUtil.initRightMenu(map2d)
                this._addRightMenu()

                // init layer
                this.RouteMarker = new RouteMarkerLayer(map2d)

                // 返回当前对象
                return this
            }
        )
    },

    /**
     * 添加右键菜单
     * TODO：模块化按需加载
     */
    _addRightMenu() {
        const self = this
        const cm = this.RightMenu

        /*// 设置起点
        const menuItem1 = new GeoGlobe.MenuItem({
            text: '以此为起点',
            callback: function(e) {
                self.fire('on-start-set', e.lngLat.toArray())
            }
        })
        // 设置途经点
        const menuItem2 = new GeoGlobe.MenuItem({
            text: '以此为途经点',
            callback: function(e) {
                self.fire('on-through-set', e.lngLat.toArray())
            }
        })
        // 设置终点
        const menuItem3 = new GeoGlobe.MenuItem({
            text: '以此为终点',
            callback: function(e) {
                self.fire('on-end-set', e.lngLat.toArray())
            }
        })*/

        /* ********公用部分START********* */
        const menuItem4 = new GeoGlobe.MenuItem({
            text: '放大',
            callback: function(e) {
                e.map.zoomIn()
            }
        })
        const menuItem5 = new GeoGlobe.MenuItem({
            text: '缩小',
            callback: function(e) {
                e.map.zoomOut()
            }
        })
        const menuItem6 = new GeoGlobe.MenuItem({
            text: '居中',
            callback: function(e) {
                const { lngLat, map } = e
                map.setCenter(lngLat)
            }
        })
        /* ********公用部分END********* */

/*        const menuItem7 = new GeoGlobe.MenuItem({
            text: '在此点附近找...',
            callback: function(e) {
                self.fire('on-around-sarch', e.lngLat.toArray())
            }
        })*/

        /* ********ADD ITEM********* */
/*        cm.addItem(menuItem1)
        cm.addItem(menuItem2)
        cm.addItem(menuItem3)
        cm.addSeparator()*/
        cm.addItem(menuItem4)
        cm.addItem(menuItem5)
        cm.addItem(menuItem6)
        /*  cm.addSeparator()
          cm.addItem(menuItem7)*/
    },

    _extend(mapView) {
        this.__proto__ = mapView
        // layer-change事件派发
        const timestampInvoker = TimestampUtil.getTimestampInvoker(500)
        const emitMapChange = () => {
            timestampInvoker.invoke(() => {
                global.ROOTVM.$store.commit('map/setMap2dChanged')
            })
        }
        mapView.on('layer-change', function(layer) {
            if (layer.metadata.group === groups[0]) {
                emitMapChange()
            }
        })
    },

    /************************* 扩展的方法 ***************************/

    /**
     * 默认背景透明的popup
     * @param {*} dom dom元素
     */
    newPopup(dom) {
        return new mapboxgl.Popup({
            anchor: 'bottom',
            showArrow: false,
            closeOnClick: false,
            closeButton: false,
            className: 'emap-map-popup',
        }).setDOMContent(dom);
    },
    // 开启浮云框
    openPopup(...rest) {
        this.vm.popupRequest.open(...rest);
    },

    // 关闭浮云框
    closePopup(...rest) {
        this.vm.popupRequest.hide(...rest);
    }
}

/**
 * 路径起点终点途经点显示类
 */
class RouteMarkerLayer {
    constructor(map) {
        this._markerLayer = new BaseMarkerLayer(map)
        this.config = global.CONFIG.routeIconConfig
    }

    /**
     * 表单
     * marker会根据Marker进行更新渲染
     */
    set Model(model) {
        this.clear()
        if (model) {
            for (const key in model) {
                const item = model[key]
                // 数组类型
                if (isArray(item)) {
                    for (let i = 0; i < item.length; i++) {
                        const { value } = item[i]
                        this._addMarker(value, key, i)
                    }
                }
                // 常规类型
                else {
                    const { value } = model[key]
                    this._addMarker(value, key)
                }
            }
        }
    }

    /**
     * @private
     * @param {*} f
     * @param {*} type
     * @param {*} index
     */
    _addMarker(f, type, index) {
        if (f) {
            const lngLat = [f.geometry.x, f.geometry.y]
            const marker = this._newMarker(type, index).setLngLat(lngLat)
            this._markerLayer.add(marker)
        }
    }

    /**
     * @private
     * @param {*} type
     * @param {*} index
     */
    _newMarker(type, index) {
        const config = deepCopy(this.config[type])

        if (config) {
            let c = { ...config }
            // 途经点图标
            if (type === 'through') {
                c.imageOffset[1] -= c.size[1] * index
            }
            const icon = newIcon(c)
            icon.style.cursor = 'pointer'
            const marker = newMarker(icon, { position: 'bottom' })
            return marker
        }

        return new mapboxgl.Marker()
    }

    clear() {
        this._markerLayer.clear()
    }
}
